module.exports = __webpack_public_path__ + "static/media/13d.8e18c44e.svg";